module.exports = {
	"accountSettings": {
		"title": "Pinterest",
		"connectedMessage": "Favorites automatically posted to <span class=\"italic\">{boardName}</span>.",
		"noBoardConnectedMessage": "You do not have a board connected for your 1stdibs favorites.",
		"ctaBoard": "Change board",
		"notConnectedMessage": "Instantly pin your Favorites on Pinterest.",
		"connectAccountCta": "Connect to Pinterest",
		"disconnectCta": "Disconnect Account",
		"confirmHeader": "Disconnect Account?",
		"confirmMessage": "Your Favorites will no longer<br /> automatically post to Pinterest.",
		"confirmCta": "Ok",
		"cancelCta": "Cancel"
	},
	"connectAccounts": {
		"header": "Connect Your Pinterest Account",
		"description": "Save your favorites on 1stdibs and automatically<br /> share to the Pinterest board of your choice.",
		"cta": "Connect to Pinterest",
		"cancel": "No thanks, not now"
	},
	"connectBoards": {
		"defaultBoardName": "My 1stdibs Favorites",
		"header": "Choose a Default Pinterest Board",
		"message": "Please select a default Pinterest board where we should pin your favorites.",
		"hint": "Favorites you save will be automatically pinned to this board.<br /> You can select a different default board under your account.",
		"boardConflict": "There was an issue with the board you selected. Please select another board.",
		"cta": "Done"
	},
	"tracking": {
		"tooltipShown": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "tooltip share now displayed"
		},
		"connectModalConnectAccountClicked": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "modal displayed|connect account clicked"
		},
		"connectModalTooltipShareNowClicked": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "modal displayed|tooltip share now clicked"
		},
		"connectModalPinClicked": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "modal displayed|pinterest click"
		},
		"connectClicked": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "connect account clicked"
		},
		"connectSuccessful": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "connect account successful"
		},
		"disconnectSuccessful": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "disconnect account successful"
		},
		"changeBoardClicked": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "change board clicked"
		},
		"boardUnchanged": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "done clicked|default folder unchanged"
		},
		"boardUpdated": {
			"category": "social integrations",
			"action": "pinterest connect",
			"label": "done clicked|default folder updated"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/Pinterest/pinterest.json
// module id = 1571
// module chunks = 4 13